import { useLocation } from 'react-router-dom';
import { logout } from '../../lib/auth';

const TITLES: Record<string, string> = {
  '/dashboard':          'Org Dashboard',
  '/dashboard/personal': 'My Dashboard',
  '/templates':          'Templates',
  '/ai':                 'AI Builder',
  '/reports':            'Saved Reports',
  '/schedules':          'Schedules',
  '/admin':              'Admin',
};

export function Topbar() {
  const loc = useLocation();
  const title = TITLES[loc.pathname] ?? 'LAOSS Reports';

  return (
    <header className="h-14 border-b border-border bg-surface flex items-center justify-between px-5">
      <div className="text-base font-semibold text-text-primary">{title}</div>
      <div className="flex items-center gap-3">
        <button
          onClick={() => logout()}
          className="text-xs text-text-muted hover:text-text-secondary"
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
